// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styleDiv {
    flex: 1 1 50%;
}

.secondStyleDiv {
    border-left: 1px solid gray;
    padding-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/ci/controlstyles/control.styles.settings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB","sourcesContent":[".styleDiv {\n    flex: 1 1 50%;\n}\n\n.secondStyleDiv {\n    border-left: 1px solid gray;\n    padding-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
